export enum JobMappingSourceType {
    HrisJobCode = 0,
    EmployeeJobTitle = 1,
    EmployeeJobCode = 2
}
